<app-custom-title
    title="Adjuntar Documentos para Orden {{ogOrder.folioOrden}}"
    icon="inventory.svg"
></app-custom-title>

<mat-dialog-content class="dialog-content">
    <div class="form-container">
        <mat-form-field appearance="outline" class="new-doc-input">
            <mat-label>Nombre del Nuevo Tipo de Documento</mat-label>
            <input matInput [(ngModel)]="newDocName" (keyup.enter)="addNewDocument()" placeholder="Ej: Remisión Firmada">
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="addNewDocument()" [disabled]="!newDocName.trim()">
            <mat-icon>add_circle_outline</mat-icon>
            Agregar
        </button>
    </div>

    <div class="form-container">
        <mat-form-field appearance="outline" class="template-input">
            <mat-label>Copiar Plantilla de Orden</mat-label>
            <input type="text" matInput [formControl]="templateControl" [matAutocomplete]="auto" placeholder="Buscar por folio o cliente...">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onTemplateSelected($event)">
                @for (option of filteredOrders | async; track option.id) {
                    <mat-option [value]="option">{{option.folioOrden}} - {{option.clienteRFC}}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <mat-divider></mat-divider>

    @if (uiData.length > 0) {
        <mat-list role="list" class="document-list">
            @for (doc of uiData; track $index) {
                <mat-list-item role="listitem" class="document-item">
                    <div class="document-details">
                        <div class="document-label">
                            <mat-icon [color]="doc.uploaded ? 'primary' : 'disabled'">description</mat-icon>
                            <span>{{doc.mainDoc}}</span>
                            @if (getPreviews(doc).length > 0) {
                            <span class="file-count">{{getPreviews(doc).length}} archivo(s)</span>
                            }
                        </div>

                        @if (getPreviews(doc).length > 0) {
                        <div class="files-grid">
                            @for (preview of getPreviews(doc); track $index) {
                            <div class="file-card" [class.existing]="isExistingFile(preview)">
                                <div class="file-thumb" (click)="openPreview(preview)">
                                    @if (preview.kind === 'image' && (preview.localUrl || preview.secureUrl)) {
                                    <img [src]="preview.localUrl || preview.secureUrl" [alt]="preview.name"
                                        loading="lazy" />
                                    } @else {
                                    <mat-icon class="type-icon" [ngClass]="preview.kind">
                                        {{ getFileIcon(preview) }}
                                    </mat-icon>
                                    }
                                    @if (preview.loading) {
                                    <div class="thumb-loading">
                                        <mat-progress-spinner diameter="18"></mat-progress-spinner>
                                    </div>
                                    }
                                </div>
                                <div class="file-card-footer">
                                    <span class="file-name" [matTooltip]="preview.name">{{preview.name}}</span>
                                    <div class="file-card-actions">
                                        @if (isExistingFile(preview)) {
                                        <button mat-icon-button class="mini-btn" (click)="openPreview(preview)"
                                            matTooltip="Ver / Descargar">
                                            <mat-icon>open_in_new</mat-icon>
                                        </button>
                                        <button mat-icon-button class="mini-btn warn" (click)="removeExistingFile(doc, preview)"
                                            matTooltip="Quitar archivo subido">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                        } @else {
                                        <span class="new-badge">Nuevo</span>
                                        <button mat-icon-button class="mini-btn warn" (click)="removeLocalFile(doc, preview)"
                                            matTooltip="Quitar">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    <span class="spacer"></span>
                    <div class="document-actions">
                        <input type="file" hidden #fileInput (change)="onFileSelected($event, doc)" multiple>
                        <button mat-icon-button (click)="fileInput.click()" matTooltip="Adjuntar Archivo(s)" color="primary">
                            <mat-icon>cloud_upload</mat-icon>
                        </button>
                        <button mat-icon-button (click)="removeDocument($index)" matTooltip="Eliminar tipo de documento" color="warn">
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    </div>
                </mat-list-item>
                <mat-divider></mat-divider>
            }
        </mat-list>
    } @else {
        <p class="no-docs-message">Aún no se han agregado tipos de documentos. Use el campo de arriba para comenzar.</p>
    }
</mat-dialog-content>

<!-- Lightbox de previsualización -->
@if (lightboxUrl) {
<div class="lightbox-backdrop" (click)="closeLightbox()">
    <button mat-icon-button class="lightbox-close" (click)="closeLightbox()">
        <mat-icon>close</mat-icon>
    </button>
    <img [src]="lightboxUrl" (click)="$event.stopPropagation()" alt="Vista previa" />
</div>
}

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="_close()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="_save()">Guardar Cambios</button>
</mat-dialog-actions>